export const menuList: {
    key: string;
    text?: string;
    icon?: number;
}[] = [
    {
        key: "personal",
        text: "Personal",
        icon: 0,
    },
    {
        key: "favorites",
        text: "Favorites",
        icon: 0,
    },
    {
        key: "password",
        text: "Password",
        icon: 0,
    },
    {
        key: "notification",
        text: "Notifications",
        icon: 0,
    },
    {
        key: "membership_plan",
        text: "Membership Plan",
        icon: 0,
    },
];